/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class FAQBlock extends React.Component {
    render() {
        let planQ = null,
            constants = this.props.app.config.constants,
            level = (this.props.user !== undefined) ? parseInt(this.props.user.plan.planLevel, 10) : 1;

        if (this.props.newSubscription !== undefined) {
            level = this.props.newSubscription.level;
        }

        if (this.props.isPlusUser(level) || this.props.isAgencyUser(level)) {
            planQ = (
                <div>
                    <div className="faq-q">
                        {"Your Plus Plan is too small and your Agency+ Plan is too big. Is there something in between?"}
                    </div>
                    <div className="faq-a">
                        {"Yes, we've got you covered! You can easily expand your Plus Plan by adding additional socials and feeds at any time. Add sets of 5 socials and 25 feeds for just $15 per month. You can add as many socials and feeds as you need!"}
                    </div>
                </div>
            );
        } else {
            planQ = (
                <div>
                    <div className="faq-q">
                        {"Your Pro Plan is too small and your Agency Plan is too big. Is there something in between?"}
                    </div>
                    <div className="faq-a">
                        {"Yes, we've got you covered! You can easily expand your Pro Plan by adding additional socials and feeds at any time. Add sets of 10 socials and 50 feeds for just $15 per month. You can add as many socials and feeds as you need!"}
                    </div>
                </div>
            );
        }

        return (
            <div className="faq-block clearfix">
                <h3>{"Still have questions? We've got answers."}</h3>
                <ul className="faq-list">
                    <li>
                        {planQ}
                    </li>
                    <li>
                        <div className="faq-q">
                            Can I cancel at any time?
                        </div>
                        <div className="faq-a">
                            While we hate to see our friends leave, we make it easy to change or cancel your plan at anytime from the Account Settings page.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Do you offer any discounts?
                        </div>
                        <div className="faq-a">
                            Yes, we do! Save up to 28% when you sign up for an annual plan.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            What forms of payment do you accept?
                        </div>
                        <div className="faq-a">
                            We accept Visa, MasterCard, American Express, and Paypal.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Do you offer any discounts for non-profits?
                        </div>
                        <div className="faq-a">
                            We offer a 50% discount to non-profit organizations. To receive a nonprofit discount, please send over your 501c3 or the country equivalent to support your nonprofit status. Once we've confirmed your status, we'll apply the 50% discount to all future payments. If you've already made the upgrade, we'll refund 50% of your most recent payment.
                        </div>
                    </li>
                    <li>
                        <div className="faq-q">
                            Who else uses dlvr.it?
                        </div>
                        <div className="faq-a">
                            Over 1,000,000 individuals, businesses, and brands trust dlvr.it to post more than 5M items daily to over a billion friends, fans and followers. We put smart social media automation to work for discerning curators around the globe.
                        </div>
                    </li>
                </ul>
            </div>
        );
    }

};

export default FAQBlock;
